import * as React from 'react'
import * as convertTime from 'utils/convert-time'
import * as T from 'components/ui/typography'

import IconButton from 'components/shared/icon-button'
import { cn } from 'lib/utils'
import CTooltip from 'components/shared/tooltip'
import { Calendar, Clock4, InfoIcon } from 'lucide-react'

interface IncomingSimulationProps {
    simulation: ExamSimulation
    isLive: boolean
}

const IncomingSimulationCard = React.memo<IncomingSimulationProps>(({ simulation, isLive }) => {
    const [calendarSelected, setCalendarSelected] = React.useState(false)

    const incomingDate = new Date(simulation.available_from)
    const endLiveDate = new Date(incomingDate.getTime() + (simulation.duration || 0) * 1000)

    return (
        <div className="flex flex-col justify-between h-full border p-3 rounded-lg h-full">
            <div className="flex items-start w-full justify-between">
                <div className="">
                    <T.Small className="mb-2">{simulation.name}</T.Small>
                    <T.Muted className="mb-2">{simulation.description || 'SIMULAZIONE A TEMPO'}</T.Muted>
                </div>
                <IconButton
                    className="rounded-full"
                    onClick={() => {
                        setCalendarSelected((old) => !old)
                    }}>
                    <Calendar viewBox="-3 0  30 30" className={calendarSelected ? ' text-primary' : ''} />
                </IconButton>
            </div>
            <div
                className={cn('flex flex-wrap justify-start', {
                    'justify-between': isLive,
                })}>
                <div className="flex justify-between items-center pr-3">
                    <Calendar viewBox="0 -2  30 30" className="mr-1 h-4 w-4" />
                    <T.Muted className="text-xs">{incomingDate.toLocaleDateString()}</T.Muted>
                    <Clock4 viewBox="0 -2  30 30" className="ml-1 h-4 w-4" />
                    <T.Muted className="text-xs ">
                        {!isLive
                            ? `${convertTime.padTo2Digits(incomingDate.getHours())}:${convertTime.padTo2Digits(
                                  incomingDate.getMinutes(),
                              )}`
                            : `dalle ${incomingDate.getHours()}:${convertTime.padTo2Digits(
                                  incomingDate.getMinutes(),
                              )} alle ${convertTime.padTo2Digits(endLiveDate.getHours())}:${convertTime.padTo2Digits(
                                  endLiveDate.getMinutes(),
                              )}`}
                    </T.Muted>
                </div>
                <div className="flex">
                    {isLive ? (
                        <CTooltip
                            trigger={
                                <div className="flex items-center  px-2 py-1  rounded-full  bg-accent">
                                    <InfoIcon viewBox="0 -3  30 30" className="mr-1 h-4 w-4" />
                                    <T.Small>Live</T.Small>
                                </div>
                            }
                            content={
                                <div className="max-w-[200px]">
                                    <h3 className="font-bold text-sm">Che cos&apos;è la simulazione Live?</h3>
                                    <p>
                                        Una simulazione live è un tipo di simulazione temporanea in cui i partecipanti
                                        rispondono a domande in tempo reale durante un periodo limitato.
                                    </p>
                                </div>
                            }
                        />
                    ) : null}
                </div>
            </div>
        </div>
    )
})

export default IncomingSimulationCard
